// Environment configuration with runtime switching
class EnvironmentConfig {
  constructor() {
    this.STORAGE_KEY = 'kanto-env-mode';
    this.listeners = new Set();

    // 1. localStorage override (set by in-app toggle)
    const stored = localStorage.getItem(this.STORAGE_KEY);
    if (stored) {
      this.useProduction = stored === 'production';
    } else if (process.env.REACT_APP_USE_FIREBASE_EMULATORS === 'true') {
      // 2. Explicit env var from cross-env in `npm run dev`
      this.useProduction = false;
    } else {
      // 3. Production builds default to production
      this.useProduction = process.env.NODE_ENV === 'production';
    }
  }

  isProduction() {
    return this.useProduction;
  }

  isEmulator() {
    return !this.useProduction;
  }

  getApiBaseUrl() {
    if (this.useProduction) {
      return '/api/v1'; // Uses Firebase Hosting rewrites
    }
    return 'http://localhost:5001/kanto-d22cd/us-central1/api/v1';
  }

  getFirebaseConfig() {
    return {
      useEmulators: !this.useProduction,
      authUrl: this.useProduction ? null : 'http://localhost:9199',
      firestoreHost: this.useProduction ? null : 'localhost',
      firestorePort: this.useProduction ? null : 8180,
      storageHost: this.useProduction ? null : 'localhost',
      storagePort: this.useProduction ? null : 9198,
    };
  }

  setEnvironment(useProduction) {
    this.useProduction = useProduction;
    localStorage.setItem(this.STORAGE_KEY, useProduction ? 'production' : 'emulator');
    this.notifyListeners();
    window.location.reload();
  }

  toggleEnvironment() {
    this.setEnvironment(!this.useProduction);
  }

  clearOverride() {
    localStorage.removeItem(this.STORAGE_KEY);
    window.location.reload();
  }

  hasOverride() {
    return localStorage.getItem(this.STORAGE_KEY) !== null;
  }

  addListener(callback) {
    this.listeners.add(callback);
  }

  removeListener(callback) {
    this.listeners.delete(callback);
  }

  notifyListeners() {
    this.listeners.forEach(callback => callback(this.useProduction));
  }

  getStatus() {
    return {
      environment: this.useProduction ? 'production' : 'emulator',
      apiBaseUrl: this.getApiBaseUrl(),
      useEmulators: !this.useProduction,
      hasOverride: this.hasOverride(),
    };
  }
}

const environmentConfig = new EnvironmentConfig();
export default environmentConfig;
